module.exports = __webpack_public_path__ + "static/media/r4.17462969.jpg";